export class Timer {
    constructor(callback, originalTtl) {
        this.callback = () => {
            callback()
        }
        this.originalTtl = originalTtl
        this.ended = false
    }
    
    restart() {
        let oldTimer = this.timer
        this.startTime = new Date().getTime()
        this.timer = setInterval(() => {
            this.computeTtl()
            if (this.ttl > 0) {
            } else if (this.ttl <= 0 && !this.ended) {
                this.callback()
                this.end()
            }
        }, 333)
        clearInterval(oldTimer)
    }

    stop() {
        clearInterval(this.timer)
        this.timer = null
    }

    currentTime() {
        return new Date().getTime()
    }

    elapsedTime() {
        return this.currentTime() - this.startTime
    }

    computeTtl() {
        const elapsedSeconds = Math.floor(this.elapsedTime() / 1000)
        this.ttl = this.originalTtl - elapsedSeconds
        if (this.ttl < 0) { this.ttl = 0 }
    }

    getTtl() {
        return this.ttl
    }
    
    end() {
        clearInterval(this.timer)
        this.ended = true
    }
}
